import React, { useState, useEffect } from "react";
import { newFetch, GET } from "../../../helpers/fetch";
import { Carousel } from "react-responsive-carousel";
import { NavLink } from "react-router-dom";
import moment from "moment";
import placeholderBackground from "../../../assets/images/placeholder-background.png";

import "react-responsive-carousel/lib/styles/carousel.min.css";

import { config } from "../../../config/index";
const { SERVER_URL } = config;

const CatalogueDetail = ({
  history,
  match: {
    params: { catalogue_id },
  },
}) => {
  const [catalogue, setCatalogue] = useState(null);

  const fetchCatalogue = async () => {
    let api_path = `/catalogue/${catalogue_id}`;
    try {
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setCatalogue(response.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchCatalogue();
  }, []);
  return (
    <>
      <div>
        <div
          className="d-flex bg-white justify-content-between "
          style={{ padding: "1rem", background: "#3c3c3c" }}
        >
          <div className="d-flex flex-column">
            <NavLink
              to="/catalogue"
              className="text-decoration-none"
              style={{ color: "inherit" }}
            >
              <div>
                <i className="fas fa-chevron-left pr-2"></i> Catalogue
              </div>
            </NavLink>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-center pt-4">
          <h3 className="pt-2 pl-3">{catalogue?.name}</h3>
        </div>
      </div>
      {catalogue && (
        <div className="d-flex flex-column">
          <div className="pt-5">
            {
              <Carousel
                showStatus={false}
                showArrows
                infiniteLoop
                autoPlay
                interval={3000}
                showThumbs={false}
                transitionTime={1000} // Set transition duration for fade
                swipeable={false}
              >
                {catalogue.images.length > 0 ? (
                  catalogue.images.map((image) => (
                    <div style={{ height: "250px" }} key={image.id}>
                      <img
                        style={{ maxWidth: "100%", height: "80%" }}
                        src={`${SERVER_URL}/${image.new_image}`}
                        alt=""
                      />
                    </div>
                  ))
                ) : (
                  <div>
                    <img src={placeholderBackground} alt="Placeholder" />
                  </div>
                )}
              </Carousel>
            }
          </div>
          <div className="container p-4">
            <h5 className="font-weight-bold">&nbsp;</h5>
            <p>{catalogue.description}</p>
            <div className="pt-4 font-weight-bold">How To Setup</div>
            <p>{catalogue.how_to_setup}</p>
            {/* <div className="pt-2 font-weight-bold">Date and Timing</div>
            <p>{moment(event.date).format('DD MMM YYYY, hh:mma')} - {moment(event.date).add(event.duration, 'hours').format('DD MMM YYYY, hh:mma')}</p>
            <div className="pt-2 font-weight-bold">Duration</div>
            <p>{event.duration} {event.duration > 1 ? 'hours' : 'hour'}</p>
            <div className="pt-2 font-weight-bold">Event URL</div>
            <a href={event.url}>{event.url}</a>
            <div className="pt-2 font-weight-bold">Contact Info</div>
            <p>{event.contact}</p> */}
          </div>
        </div>
      )}
    </>
  );
};

export default CatalogueDetail;
